<template>
  <div
      class="weapon-specifications__item"
  >
    <p class="item-title">
      {{ $t('categories_label') }}
    </p>
    <div class="item-labels">
      <button
          v-if="filters.normal_count"
          :class="{active: activeFilters.extra === 'NORMAL'}"
          class="item-labels-item btn btn-primary-stroke"
          @click="setFilter('extra', 'NORMAL')"
      >
        <span class="item-labels-left">{{ $t('normal') }}</span>
        <span class="item-labels-right">
            <template v-if="activeFilters.extra !== 'NORMAL'">
              {{ filters.normal_count || 0 }}
            </template>
            <i v-else class="i-times"></i>
          </span>
      </button>
      <button
          v-if="filters.stattrak_count"
          :class="{active: activeFilters.extra === 'STATTRAK'}"
          class="item-labels-item btn btn-primary-stroke"
          @click="setFilter('extra', 'STATTRAK')"
      >
        <span class="item-labels-left stattrak">StatTrak™ </span>
        <span class="item-labels-right">
            <template v-if="activeFilters.extra !== 'STATTRAK'">
              {{ filters.stattrak_count || 0 }}
            </template>
            <i v-else class="i-times"></i>
          </span>
      </button>
      <button
          v-if="filters.souvenir_count"
          :class="{active: activeFilters.extra === 'SOUVENIR'}"
          class="item-labels-item btn btn-primary-stroke"
          @click="setFilter('extra', 'SOUVENIR')"
      >
        <span class="item-labels-left souvenir">Souvenir</span>
        <span class="item-labels-right">
          <template v-if="activeFilters.extra !== 'SOUVENIR'">
            {{ filters.souvenir_count || 0 }}
          </template>
          <i v-else class="i-times"></i>
          </span>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {ItemWeaponPageFiltersResult} from "~/graphql/generated/schema-types";

const props = defineProps<{ filters: ItemWeaponPageFiltersResult }>()
const route = useRoute()
const router = useRouter()

const activeFilters = computed(() => {
  return {
    extra: route.query['extra']
  }
})

const setFilter = (name: string, value: string | null) => {
  const newQuery = {...route.query}

  if (value === null || value === newQuery[name]) {
    delete newQuery[name]
  } else {
    newQuery[name] = value
  }

  router.push({query: newQuery})
}
</script>

<style scoped>

</style>
